import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import usePromise from "../../hooks/usePromise";
export default function Skeleton({ promise, delayMs = 120, shell, children }) {
    const data = usePromise(promise);
    const [revealed, setRevealed] = React.useState(false);
    React.useEffect(() => {
        if (data === undefined) {
            setRevealed(false);
            return;
        }
        const id = window.setTimeout(() => setRevealed(true), delayMs);
        return () => clearTimeout(id);
    }, [data, delayMs]);
    if (data === undefined || !revealed) {
        return (_jsx("div", { className: "skeleton-root", "data-loading": true, children: typeof shell === "function" ? shell() : shell !== null && shell !== void 0 ? shell : (_jsx("div", { className: "skeleton-mask" })) }));
    }
    // `data` is now NonNullable<T> by control flow narrowing
    return children(data);
}
